<template>
  <div class="mc-trackvideo-card__no-video-wrapper">
    <div class="mc-trackvideo-card__no-video-content">
      <img
        width="68"
        :src="
          isWhitelabel()
            ? getAsset('secondaryLogo', 'sidebarMinimize')
            : require('@/assets/images/mceasy-large.png')
        "
      />
      <p>{{ $t('trackVideo.state.noVideo') }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      isWhitelabel: 'identity/isWhitelabel',
    }),
  },
}
</script>
<style lang="scss">
.mc-trackvideo-card__no-video-wrapper {
  height: 100%;
  width: 100%;
  background-color: $blue-900;
  display: flex;
  align-items: center;
  justify-content: center;
  .mc-trackvideo-card__no-video-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      color: $white;
    }
  }
}
</style>
